window.handleQuickView = function (event) {
  const button = event.currentTarget;
  const productUrl = button.dataset.productUrl;
  if (productUrl) {
    window.open(productUrl, "_blank");
  }
};

window.handleAddToCart = async (event) => {
  const button = event.currentTarget;
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.textContent = "Adding...";
  button.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });

    if (!response.ok) throw new Error("Failed to add to cart");

    await response.json();
    await window.refreshCart();

    button.textContent = "Added!";
    setTimeout(() => {
      button.textContent = "ADD";
      button.disabled = false;
    }, 2000);
  } catch (error) {
    console.error("Add to cart error:", error);
    button.textContent = "Error";
    setTimeout(() => {
      button.textContent = "ADD";
      button.disabled = false;
    }, 2000);
  }
};

window.refreshCart = async () => {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart } })
    );

    if (typeof window.updateCartDrawer === "function") {
      window.updateCartDrawer();
    } else {
      await window.fetchCartDrawerHTML();
    }
  } catch (error) {
    console.error("Error refreshing cart:", error);
  }
};

window.fetchCartDrawerHTML = async () => {
  try {
    const response = await fetch("/?sections=cart-drawer");
    const data = await response.json();

    if (data["cart-drawer"]) {
      const drawer = document.querySelector("cart-drawer");
      if (drawer) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data["cart-drawer"], "text/html");
        const newContent = doc.querySelector(".drawer__inner");

        if (newContent) {
          const currentContent = drawer.querySelector(".drawer__inner");
          if (currentContent) currentContent.innerHTML = newContent.innerHTML;
        }
      }
    }
  } catch (error) {
    console.error("Error fetching drawer HTML:", error);
  }
};

window.scrollToSlide = (slideIndex) => {
  const carousel = document.getElementById("cart-upsell-carousel");
  const slide = carousel?.children[slideIndex];
  if (slide) {
    slide.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest",
    });
  }
};
window.handleCarouselScroll = function () {
  const container = document.getElementById("cart-upsell-carousel");
  const dots = document.querySelectorAll(".cart-upsell__dot");
  const slideWidth = container.offsetWidth;
  const scrollLeft = container.scrollLeft;
  const activeIndex = Math.round(scrollLeft / slideWidth);
  updateActiveDot(activeIndex);
};

function updateActiveDot(index) {
  const dots = document.querySelectorAll(".cart-upsell__dot");
  dots.forEach((dot, i) => {
    dot.classList.toggle("active", i === index);
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function findVariant(options, searchText) {
  // Split the searchText into parts by "/" and sort them for comparison
  const searchParts = searchText.split(" / ").sort();

  // Iterate through the options array to find the match
  for (let option of options) {
    const [id, price, text] = option.split(" - ");
    // Split the option text into parts and sort them for comparison
    const optionParts = text.split(" / ").sort();

    // Count how many parts match, ignoring order
    const matchCount = searchParts.reduce((count, part) => {
      return optionParts.includes(part) ? count + 1 : count;
    }, 0);

    // Return if at least two parts match
    if (matchCount >= 2) {
      return { id, price };
    }
  }

  // Return null if no match is found
  return null;
}

const optionsUpsell = [
  "48018593153257 - 65.00 - moonbeam_performance-microsuede / Add Waterproof Liners",
  "48018593186025 - 60.00 - moonbeam_performance-microsuede / Remove Waterproof Liners",
  "48018593218793 - 65.00 - ocean_performance-microsuede / Add Waterproof Liners",
  "48018593251561 - 60.00 - ocean_performance-microsuede / Remove Waterproof Liners",
  "48018593349865 - 65.00 - pine_classic-microsuede / Add Waterproof Liners",
  "48018593382633 - 60.00 - pine_classic-microsuede / Remove Waterproof Liners",
  "48018593415401 - 65.00 - calamine_performance-microsuede / Add Waterproof Liners",
  "48018593448169 - 60.00 - calamine_performance-microsuede / Remove Waterproof Liners",
  "48018593480937 - 65.00 - sagebrush_performance-microsuede / Add Waterproof Liners",
  "48018593513705 - 60.00 - sagebrush_performance-microsuede / Remove Waterproof Liners",
  "48018593546473 - 65.00 - riverrock_performance-microsuede / Add Waterproof Liners",
  "48018593579241 - 60.00 - riverrock_performance-microsuede / Remove Waterproof Liners",
  "48018593612009 - 65.00 - muavemist_luxe-velvet / Add Waterproof Liners",
  "48018593644777 - 60.00 - muavemist_luxe-velvet / Remove Waterproof Liners",
  "48018593677545 - 65.00 - dune_luxe-velvet / Add Waterproof Liners",
  "48018593710313 - 60.00 - dune_luxe-velvet / Remove Waterproof Liners",
  "48018593743081 - 65.00 - moss_luxe-corded-plush / Add Waterproof Liners",
  "48018593775849 - 60.00 - moss_luxe-corded-plush / Remove Waterproof Liners",
  "48018593808617 - 65.00 - tumbleweed_luxe-flatweave / Add Waterproof Liners",
  "48018593841385 - 60.00 - tumbleweed_luxe-flatweave / Remove Waterproof Liners",
  "48018593874153 - 65.00 - charcoal_luxe-flatweave / Add Waterproof Liners",
  "48018593906921 - 60.00 - charcoal_luxe-flatweave / Remove Waterproof Liners",
  "48027721466089 - 65.00 - sky_classic-microsuede / Add Waterproof Liners",
  "48027721498857 - 60.00 - sky_classic-microsuede / Remove Waterproof Liners",
  "48659876577513 - 65.00 - sundance_luxe-corded-plush / Add Waterproof Liners",
  "48659876610281 - 60.00 - sundance_luxe-corded-plush / Remove Waterproof Liners"
];


function findMatchingVariant(product, currentVariant, targetOption2) {
  // Use Array.find to locate the matching variant
  return (
    product.variants.find(
      (variant) =>
        variant.option1 === currentVariant.option1 &&
        variant.option2 === targetOption2 &&
        variant.option3 === currentVariant.option3
    ) || null // Return null if no match is found
  );
}

async function initUpsellButton() {
  const container = document.querySelector('[data-option="Size"]');
  if (!container) return;

  const forTwoRadio = container.querySelector("#forTwoRadio");
  const forOneRadio = container.querySelector("#forOneRadio");

  const productHandle = forTwoRadio.getAttribute("data-product-handle");
  const currentVariantId = forTwoRadio.getAttribute("data-variant-id");
  const firstAvailableVariantId = forTwoRadio.getAttribute(
    "data-product-first-variant"
  );

  const productResponse = await fetch(`/products/${productHandle}.js`);
  const parsedResponse = await productResponse.json();

  const currentVariant = parsedResponse.variants.find(
    (v) => v.id === Number(currentVariantId)
  );
  const firstAvailableVariant = parsedResponse.variants.find(
    (v) => v.id === Number(firstAvailableVariantId)
  );

  function saveSelection() {
    localStorage.setItem("selectedSizeOption", "8_Pieces");
  }

  function clearSelection() {
    localStorage.removeItem("selectedSizeOption");
  }

  function restoreSelection() {
    const savedSelection = localStorage.getItem("selectedSizeOption");
    if (savedSelection === "8_Pieces") {
      forTwoRadio.click(); // Simulate a click to reselect the option
    }
  }

  forTwoRadio.addEventListener("click", async function () {
    if (forTwoRadio.classList.contains("variant_selected")) return;

    const match = findMatchingVariant(
      parsedResponse,
      currentVariant,
      "7_Pieces"
    );
    if (!match) return;

    const { price, id: itemToAddId } = findVariant(optionsUpsell, match.title);
    console.log("HERE", price, itemToAddId)

    document.querySelector(".product-variant-id").value = String(match.id);

    document.querySelectorAll(".remove-size-option").forEach((element) => {
      element.style.visibility = "visible";
    });

    container.querySelectorAll(".variant_selected").forEach((v_c) => {
      v_c.style.setProperty(
        "border",
        "1px solid rgba(var(--color-neutral-1))",
        "important"
      );
      v_c.style.setProperty("outline", "none", "important");
    });

    forTwoRadio.classList.add("variant_selected", "selected", "upsell-option");

    const linersCharge = document.querySelector(".liners-percentage-off");
    linersCharge.innerHTML = "Normally $119. Save with purchase."

    const linersChargeInsideRadio = document.querySelector(
      ".liners-inside-option-charge"
    );
    linersChargeInsideRadio.innerHTML = "$120 with purchase";

    
    let currentPrice = Number(match.price) / 100 + Number(price);
    let amountToDiscount = 0;

      if (match.title.includes("7_Pieces")) {
          if (match.title.includes("Add Waterproof")) {
            amountToDiscount += 69;
          } else {
            amountToDiscount += 40;
          }
      }

    document
      .querySelectorAll(".price-item.price-item--regular.h4")
      .forEach((element) => {
        let price = currentPrice;
        element.innerHTML = `$${price.toFixed(
          2
        )} <strike style="color: #0000004A;">$${(
          price + amountToDiscount
        ).toFixed(2)}</strike>`;
      });

    forTwoRadio.setAttribute("data-upsell-id", String(itemToAddId));

    saveSelection();
  });

  document.querySelectorAll(".remove-size-option").forEach((button) => {
    button.addEventListener("click", function (e) {
      container
        .querySelectorAll(".variant_selected, .selected, .upsell-option")
        .forEach((element) => {
          element.classList.remove(
            "variant_selected",
            "selected",
            "upsell-option"
          );
        });

      e.target.style.visibility = "hidden";

      const priceElements = document.querySelectorAll(
        ".price-item.price-item--regular.h4"
      );
      let currentPrice = Number(currentVariant.price) / 100;

      priceElements.forEach((element) => {
        element.innerHTML = `$${currentPrice.toFixed(2)}`;
      });

      document.querySelector(".product-variant-id").value = String(
        firstAvailableVariantId
      );

      clearSelection();
    });
  });

  forOneRadio.addEventListener("click", function () {
    container.querySelectorAll(".variant_selected").forEach((v_c) => {
      v_c.classList.remove("variant_selected", "selected", "upsell-option");
    });

    document.querySelectorAll(".remove-size-option").forEach((element) => {
      element.style.visibility = "hidden";
    });

    clearSelection();
  });

  restoreSelection();
}

// Add watcher to all top level (desktop only) navigation links that have an associated mega-menu
// document.querySelectorAll('[id^="Nav-"] summary').forEach((summary) => {
//   console.log(summary);
//   // let megamenu = summary.getAttribute('data-menu');
//   summary.addEventListener('mouseenter', activateMegaMenu); //triger function to show mega-menu
// });

// Add watcher to the overall header container to close any megamenus when the mouse leaves it
// document.querySelector('header').addEventListener('mouseleave', function() {
//   document.querySelectorAll('.mega-menu__content').forEach((mmenu) => {
//       mmenu.classList.remove("show");
//   });
// });

// Show the associated mega menu when a top level (desktop only) link is hovered over
function activateMegaMenu(event) {
  let menukey = event.target.getAttribute("data-menu");
  let menu = document.getElementById("MegaMenu-Content-" + menukey);

  //if any menus are already visible, remove class
  document.querySelectorAll(".mega-menu__content").forEach((mmenu) => {
    if (mmenu != menu) {
      mmenu.classList.remove("show");
    }
  });
  //add show class to current menu
  menu.classList.add("show");
}

// document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
//   console.log(summary);
//   summary.setAttribute('role', 'button');
//   summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

//   if(summary.nextElementSibling.getAttribute('id')) {
//     summary.setAttribute('aria-controls', summary.nextElementSibling.id);
//   }

//   summary.addEventListener('click', (event) => {
//     event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//   });

//   if (summary.closest('header-drawer')) return;
// summary.parentElement.addEventListener('keyup', onKeyUpEscape);
// });

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    // this.closeAnimation(this.mainDetailsToggle);
    this.mainDetailsToggle.removeAttribute("open");
    const childElement = document.querySelector("#header-contents");
    childElement.classList.remove("header-contents-width");
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (event.currentTarget.hasAttribute("data-ignore-close")) {
      return;
    }
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.header = document.querySelector(".section-header");
    this.borderOffset = this.closest(".header-wrapper")?.classList.contains(
      "header-wrapper--border-bottom"
    )
      ? 1
      : 0;

    this.setHeaderCustomProperties();
    window.addEventListener("scroll", this.onResize);
    window.addEventListener("resize", this.onResize);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const childElement = document.querySelector("#header-contents");
    childElement.classList.add("header-contents-width");
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.setHeaderCustomProperties();
  };

  setHeaderCustomProperties() {
    const headerRect = this.header.getBoundingClientRect();

    document.documentElement.style.setProperty(
      "--header-top-position",
      `${Math.max(parseInt(headerRect.y + headerRect.height), 0)}px`
    );

    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(headerRect.bottom - this.borderOffset)}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton?.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    document
      .getElementById("forTwoRadio")
      .addEventListener("click", (e) => this.renderProductInfoUpsell());
  }

  onVariantChange(e, fabricTier) {
    if (e.srcElement.defaultValue.includes("Pieces")) {
      localStorage.removeItem("selectedSizeOption");
    }
    if (e && e.target.dataset.value) return;
    this.updateOptions();
    this.updateMasterId();
    const currentValues = document
      .querySelector(".wrapp-couches-upsell")
      ?.querySelector(".variant_selected")?.dataset;
    if (currentValues && currentValues.variantId) {
      const isUpsellSelected = Boolean(
        document.querySelector(".upsell-option")
      );
      const { variantId } = currentValues;
      const requestedVariantId = this?.currentVariant?.id;
      if (
        !isUpsellSelected &&
        requestedVariantId &&
        variantId &&
        Number(variantId) === requestedVariantId
      ) {
        return;
      }
    }
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo(fabricTier);
      this.updateShareUrl();
      // this.updateMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    // if (!this.currentVariant) return;
    // if (!this.currentVariant.featured_media) return;
    // console.log(`${this.currentVariant.metafields}`);
    // console.log('current variant:');
    // console.log(this.currentVariant);
    // console.log(this.currentVariant.sku);
    // console.log('featured media:');
    // console.log(this.currentVariant.featured_media);
    // console.log('featured media id:');
    // console.log(`${this.currentVariant.featured_media.id}`);
    // console.log('gallery selector:');
    // console.log(`${this.dataset.section}`);
    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // console.log('media galleries:');
    // console.log(mediaGalleries);
    // // if selected variant has images assigned to it replace entire gallery
    // mediaGalleries.forEach((mediaGallery) =>
    //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    // );
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);
    // var material = metaData[this.currentVariant.sku];
    // console.log('material:');
    // console.log(material);
    // alert('Media');
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(fabricTier) {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        console.log(html);

        const scriptElement = html.querySelector(
          'script[type="application/json"]'
        );
        const data = JSON.parse(scriptElement.textContent.trim());
        const variantMatch = data
          .find((e) => e.id == requestedVariantId)
          ?.title.includes("7_Pieces");
        console.log("Match", variantMatch);

        // Price
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );

        // SKU
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );

        // Accordion
        const accordionSource = html.querySelector(".accordion-list");
        const accordionDestination = document.querySelector(`.accordion-list`);

        // Inventory
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        // Media Gallery
        const mediaSource = html.getElementById(
          `MediaGallery-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const mediaDestination = document.getElementById(
          `MediaGallery-${this.dataset.section}`
        );

        // Variant Radios
        const radioSource = html.getElementById(
          `variant-radios-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const radioDestination = document.getElementById(
          `variant-radios-${this.dataset.section}`
        );

        // show correct price
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          if (document.getElementById(`unit-price-${this.dataset.section}`)) {
            document.getElementById(
              `unit-price-${this.dataset.section}`
            ).innerHTML = source.innerHTML;
          }
        }

        // show correct inventory
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        // show correct sku
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        // show correct accordion
        if (accordionSource && accordionDestination) {
          accordionDestination.innerHTML = accordionSource.innerHTML;
        }

        // show correct media gallery
        if (mediaSource && mediaDestination) {
          mediaDestination.innerHTML = mediaSource.innerHTML;

          // console.log(customElements.get('media-gallery'));
          // // re-enable slider functionality
          // // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-"]`);
          // console.log('media galleries:');
          // console.log(mediaSource);
          // // if selected variant has images assigned to it replace entire gallery
          // // mediaSource.forEach((mediaSource) =>
          // mediaSource.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
          // // );
          // const modalContent = document.querySelector(
          //   `#ProductModal-${this.dataset.section} .product-media-modal__content`
          // );
          // if (!modalContent) return;
          // const newMediaModal = modalContent.querySelector(
          //   `[data-media-id="${this.currentVariant.featured_media.id}"]`
          // );
          // modalContent.prepend(newMediaModal);
          // var material = metaData[this.currentVariant.sku];
          // console.log('material:');
          // console.log(material);
          // alert('Media');
        }

        // show correct state of variant radios
        if (radioSource && radioDestination) {
          const activeColorTabTier = radioDestination.querySelector(
            `color-tabs [data-tabs-button].is-active`
          )?.dataset.fabricTier;

          radioDestination.innerHTML = radioSource.innerHTML;

          if (activeColorTabTier || activeColorTabTier) {
            const updatedActiveButton = radioDestination.querySelector(
              `color-tabs [data-tabs-button][data-fabric-tier="${
                fabricTier ? fabricTier : activeColorTabTier
              }"]`
            );

            updatedActiveButton.click();
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        initUpsellButton();
      });
  }

  renderProductInfoUpsell() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );

        // SKU
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );

        // Inventory
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        // Media Gallery
        const mediaSource = html.getElementById(
          `MediaGallery-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const mediaDestination = document.getElementById(
          `MediaGallery-${this.dataset.section}`
        );

        // show correct inventory
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        // show correct sku
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        // show correct media gallery
        if (mediaSource && mediaDestination) {
          mediaDestination.innerHTML = mediaSource.innerHTML;

          // console.log(customElements.get('media-gallery'));
          // // re-enable slider functionality
          // // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-"]`);
          // console.log('media galleries:');
          // console.log(mediaSource);
          // // if selected variant has images assigned to it replace entire gallery
          // // mediaSource.forEach((mediaSource) =>
          // mediaSource.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
          // // );
          // const modalContent = document.querySelector(
          //   `#ProductModal-${this.dataset.section} .product-media-modal__content`
          // );
          // if (!modalContent) return;
          // const newMediaModal = modalContent.querySelector(
          //   `[data-media-id="${this.currentVariant.featured_media.id}"]`
          // );
          // modalContent.prepend(newMediaModal);
          // var material = metaData[this.currentVariant.sku];
          // console.log('material:');
          // console.log(material);
          // alert('Media');
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        initUpsellButton();
        console.log("change!!!");
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(
        fieldset.querySelectorAll("input:not([data-value])")
      ).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// add custom functionality to assign the appropriate classes when a callout block + callout is interacted with
function activateCallout(e, d) {
  // console.log(e);
  var callouts = e.parentElement.parentElement.parentElement.querySelectorAll(
    '[data-callout="' + e.getAttribute("data-callout") + '"]'
  );
  console.log(callouts);
  if (d == "enter") {
    e.parentElement.parentElement.parentElement.classList.add("active");
    // e.setAttribute('data-active', 'true');
    for (var c = 0; c < callouts.length; c++) {
      callouts[c].setAttribute("data-active", "true");
    }
  } else {
    e.parentElement.parentElement.parentElement.classList.remove("active");
    // e.setAttribute('data-active', 'false');
    for (var c = 0; c < callouts.length; c++) {
      callouts[c].setAttribute("data-active", "false");
    }
  }
}

document
  .querySelector("li.grid__item:first-of-type")
  ?.classList.remove("is-active");

document
  .querySelector("li.grid__item:nth-of-type(2)")
  ?.classList.add("is-active");
